import styled from 'styled-components';

export const PageWrapper = styled.div`
  background-color: ${({ theme }) => theme.new.colors.neutral100};
  min-height: 100vh;
`;

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 3.2rem;
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const Title = styled.h1`
  ${({ theme }) => theme.new.typography.h1SemiBold};
  color: ${({ theme }) => theme.new.colors.neutral900};
  margin: 0;
`;

export const ProjectCountsRow = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.new.typography.p6Medium};
  color: ${({ theme }) => theme.new.colors.neutral600};
  gap: 1.2rem;
`;

const badgeBackground = {
  active: 'rgba(59, 130, 246, 0.08)',
  pipeline: 'rgba(255, 152, 0, 0.08)'
};

const badgeColor = {
  active: '#2563eb',
  pipeline: '#d97706'
};

export const CountBadge = styled.span`
  ${({ theme }) => theme.new.typography.p6Medium};
  padding: 0.2rem 0.8rem;
  border-radius: 4px;
  background: ${({ $variant }) => badgeBackground[$variant] || '#f3f4f6'};
  color: ${({ $variant }) => badgeColor[$variant] || '#374151'};
`;

export const Separator = styled.span`
  color: ${({ theme }) => theme.new.colors.neutral300};
  font-weight: 300;
`;

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.6rem;
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.new.colors.white};
  border-radius: 1.2rem;
  box-shadow: 0 2px 10px -4px rgba(0, 0, 0, 0.05);
  border: 1px solid ${({ theme }) => theme.new.colors.neutral200};
  overflow: hidden;
`;

export const CardHeader = styled.div`
  padding: 2rem 2.4rem;
  border-bottom: 1px solid ${({ theme }) => theme.new.colors.neutral200};
`;

export const CardTitle = styled.h2`
  ${({ theme }) => theme.new.typography.h3};
  color: ${({ theme }) => theme.new.colors.black};
  margin: 0 0 0.4rem 0;
`;

export const CardDescription = styled.p`
  ${({ theme }) => theme.new.typography.p5};
  color: ${({ theme }) => theme.new.colors.neutral600};
  margin: 0;
`;

export const ChartCard = styled(Card)`
  padding: 2.4rem;
`;

export const ChartTitle = styled.h2`
  ${({ theme }) => theme.new.typography.p3Bold};
  color: ${({ theme }) => theme.new.colors.black};
  margin: 0 0 0.4rem 0;
`;

export const SearchRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;
